import Vue from 'vue';
/* eslint-disable import/no-cycle */
import Api from '@/api';
import Util from '@/util';
/* eslint-enable import/no-cycle */

const theState = {
    loading: true,
    inAction: false,
    valid: false,
    ssoId: '',
    emailAlert: {
        show: false,
        type: 'error',
        message: 'Es existiert bereits ein Nutzer mit dieser Email.',
    },
    gpNumber: '',
    noResult: false,
    portal: '',
    scope: '',
    anrede: '',
    titel: '',
    vorname: '',
    nachname: '',
    strasse: '',
    hausnummer: '',
    plz: '',
    ort: '',
    land: '',
    email: '',
    gebdat: '',
    telnr: '',
    sendMailing: true,
    allPortals: [{
        scope: 'MHN',
        color: 'success',
        value: 'SHZ',
        label: 'sh:z',
    }, {
        scope: 'MHN',
        color: 'success',
        value: 'SVZ',
        label: 'medienhaus:nord / SVZ',
    }, {
        scope: 'MHN',
        color: 'success',
        value: 'NNN',
        label: 'NNN',
    }, {
        scope: 'MHN',
        color: 'success',
        value: 'BEIG',
        label: 'A. Beig Verlag',
    }, {
        scope: 'MHN',
        color: 'success',
        value: 'PRIGNITZER',
        label: 'medienhaus:nord / Prignitzer',
    }, {
        scope: 'NOZ',
        color: 'success',
        value: 'NOZ',
        label: 'NOZ',
    }, {
        scope: 'NOZ',
        color: 'success',
        value: 'DK',
        label: 'Delmenhorster Kreisblatt',
    }],
};

const getters = {
    portals(state) {
        return state.allPortals.filter(p => (!state.scope || state.scope === p.scope));
    },
};

const actions = {
    loadData({ commit, dispatch }, { gpNumber, scope }) {
        commit('setLoading', true);
        commit('setGpNumber', gpNumber);
        commit('setScope', scope);
        commit('setNoResult', false);
        commit('setValid', false);
        commit('setPortal', '');
        dispatch('setData', {
            anrede: '',
            titel: '',
            vorname: '',
            nachname: '',
            strasse: '',
            hausnummer: '',
            plz: '',
            ort: '',
            land: '',
            email: '',
            gebdat: '',
            telnr: '',
        });
        return new Promise((resolve) => {
            Api.customer
                .getByGpId(gpNumber, scope)
                .then(({ data }) => {
                    const { gebdat } = data.data;
                    const birthdate = Util.toDate(gebdat);
                    dispatch('setData', {
                        ...data.data,
                        gebdat: gebdat !== birthdate ? birthdate : '',
                    });
                }).catch(() => {
                    commit('setNoResult', true);
                }).finally(() => {
                    commit('setLoading', false);
                    resolve();
                });
        });
    },

    submit({ commit, dispatch }) {
        commit('setInAction', true);
        return new Promise((resolve, reject) => {
            dispatch('doesEmailExist')
                .then(() => resolve())
                .catch(() => reject());
        });
    },

    doesEmailExist({ commit, state, dispatch }) {
        return new Promise((resolve, reject) => {
            Api.validate.emailExist(state.email)
                .then(({ data }) => {
                    if (data.emailExist) {
                        commit('setEmailAlertMessage', 'E-Mail existiert bereits in celeraone.');
                        commit('setInAction', false);
                        commit('showEmailAlert');
                        reject();
                    } else if (data.emailInvalid) {
                        commit('setEmailAlertMessage', 'Diese E-Mail ist nicht erlaubt.');
                        commit('setInAction', false);
                        commit('showEmailAlert');
                        reject();
                    } else {
                        dispatch('createCustomerFromSap')
                            .then(() => resolve())
                            .catch(() => reject());
                    }
                })
                .catch(() => {
                    commit('setInAction', false);
                    commit('setEmailAlertMessage', 'Mit der eingegeben E-Mail stimmt etwas nicht.');
                    commit('showEmailAlert');
                    reject();
                });
        });
    },

    createCustomerFromSap({ commit, state, dispatch }) {
        return new Promise((resolve, reject) => {
            Api.customer.createCustomerFromSap({
                email: state.email.trim(),
                gpnumber: state.gpNumber.trim(),
                scope: state.scope.trim(),
                anrede: state.anrede.trim(),
                titel: state.titel.trim(),
                vorname: state.vorname.trim(),
                nachname: state.nachname.trim(),
                strasse: state.strasse.trim(),
                hausnummer: state.hausnummer.trim(),
                plz: state.plz.trim(),
                ort: state.ort.trim(),
                land: state.land.trim(),
                gebdat: state.gebdat.trim(),
                telnr: state.telnr.trim(),
                portal: state.portal.trim(),
                sendMailing: state.sendMailing,
            }).then(({ data }) => {
                commit('snackbar/success', 'Der Nutzer wurde erfolgreich angelegt. '
                    + 'Dem Nutzer wird eine Mail mit seinem initialen Passwort  zugeschickt. '
                    + 'Außerdem wird der Nutzer aufgefordert seinen Account zu aktivieren. '
                    + 'Es werden nun die Produkte übertragen.', { root: true });
                dispatch('activateUser', { ssoId: data.data.user_id })
                    .then(() => resolve())
                    .catch(() => reject());
            }).catch(() => {
                commit('snackbar/error', 'Das Übertragen des Nutzers war fehlerhaft.', { root: true });
                commit('setInAction', false);
                commit('setSsoId', '');
                reject();
            });
        });
    },

    activateUser({ commit, state }, { ssoId }) {
        commit('setSsoId', ssoId);
        return new Promise((resolve) => {
            Api.customer
                .linkUserToOrder(ssoId, state.gpNumber, state.scope, false)
                .then(() => {
                    commit('snackbar/success', 'Produkte erfolgreich übertragen.', { root: true });
                }).catch(() => null) // {
                // Fehlermeldung deaktiviert, bis MSP-API keine Timeouts mehr liefert
                // commit('snackbar/error', 'Produktübertragung fehlgeschlagen.', { root: true });
                // reject();
                // })
                .finally(() => {
                    commit('setInAction', false);
                    resolve();
                });
        });
    },

    setData({ commit }, {
        anrede,
        titel,
        vorname,
        nachname,
        strasse,
        hausnummer,
        plz,
        ort,
        land,
        email,
        gebdat,
        telnr,
    }) {
        commit('setAnrede', anrede);
        commit('setTitel', titel);
        commit('setVorname', vorname);
        commit('setNachname', nachname);
        commit('setStrasse', strasse);
        commit('setHausnummer', hausnummer);
        commit('setPlz', plz);
        commit('setOrt', ort);
        commit('setLand', land);
        commit('setEmail', email);
        commit('setGebdat', gebdat);
        commit('setTelnr', telnr);
    },
};

const mutations = {
    setScope(state, scope) {
        state.scope = scope;
    },

    setPortal(state, portal) {
        state.portal = portal;
    },

    setValid(state, valid) {
        state.valid = valid;
    },

    setGpNumber(state, gpNumber) {
        state.gpNumber = gpNumber;
    },

    setLoading(state, loading) {
        state.loading = loading;
    },

    setSsoId(state, ssoId) {
        state.ssoId = ssoId;
    },

    setInAction(state, inAction) {
        state.inAction = inAction;
    },

    setNoResult(state, noResult) {
        state.noResult = noResult;
    },

    showEmailAlert(state) {
        Vue.set(state.emailAlert, 'show', true);
    },

    hideEmailAlert(state) {
        Vue.set(state.emailAlert, 'show', false);
    },

    setEmailAlertMessage(state, message) {
        Vue.set(state.emailAlert, 'message', message);
    },

    setAnrede(state, anrede) {
        state.anrede = anrede;
    },

    setTitel(state, titel) {
        state.titel = titel;
    },

    setVorname(state, vorname) {
        state.vorname = vorname;
    },

    setNachname(state, nachname) {
        state.nachname = nachname;
    },

    setStrasse(state, strasse) {
        state.strasse = strasse;
    },

    setHausnummer(state, hausnummer) {
        state.hausnummer = hausnummer;
    },

    setPlz(state, plz) {
        state.plz = plz;
    },

    setOrt(state, ort) {
        state.ort = ort;
    },

    setLand(state, land) {
        state.land = land;
    },

    setEmail(state, email) {
        state.email = email;
    },

    setGebdat(state, gebdat) {
        state.gebdat = gebdat;
    },

    setTelnr(state, telnr) {
        state.telnr = telnr;
    },

    setSendMailing(state, value) {
        state.sendMailing = value === true;
    },
};

export default {
    namespaced: true,
    state: theState,
    getters,
    actions,
    mutations,
};
